<template>
  <div class="custom-player">
    <div class="video-player-container">
      <video ref="videoPlayer" class="video-player" playsinline id="videoPlayercutom"></video>
      <div v-if="!playing" class="video-placeholder" @click.stop="togglePlay"></div>

      <!-- 简化后的控制条 -->
      <div class="player-controls">
        <button v-if="videoType === 'history' || !playing" class="control-btn" @click.stop="togglePlay">
          {{ playing ? '❚❚' : '▶' }}
        </button>

        <div class="play-tools">
          <!-- 倍速 -->
          <el-popover placement="top" trigger="hover" popper-class="rate-popper">
            <ul class="tools-box">
              <li
                :class="{ active: rate.value === selectedRate }"
                v-for="rate in rateOptions"
                :key="rate.value"
                @click="selectedRateFn(rate.value)"
              >
                {{ rate.label }}
              </li>
            </ul>

            <span slot="reference" v-if="this.videoType === 'history'" class="frame-rate">倍速</span>
          </el-popover>
          <!-- 垂直音量控制条 -->
          <el-popover placement="top" trigger="hover" popper-class="volume-popper">
            <input
              type="range"
              min="0"
              max="1"
              step="0.1"
              v-model="volume"
              @click.stop
              @input="changeVolume($event)"
              class="vertical-volume-slider"
              orient="vertical"
            />

            <button slot="reference" class="control-btn" @click.stop="toggleMute">
              {{ muted ? '🔇' : '🔊' }}
            </button>
          </el-popover>

          <button v-if="croping" class="control-btn el-icon-scissors" @click.stop="cropingFn"></button>
          <button class="control-btn fullscreen-btn" @click.stop="toggleFullscreen">⛶</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mpegtsjs from 'mpegts.js';
import request from '@/utils/request';
import api from '@/utils/api';
import { Message, MessageBox } from 'element-ui';
import WsSocket from '@/utils/websocket';
export default {
  props: {
    devNum: {
      type: String,
      default: ''
    },
    croping: {
      type: Boolean,
      default: true
    },
    videoType: {
      type: String,
      default: ''
    },
    startTime: {
      type: String,
      default: ''
    },
    endTime: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      volume: 0, // 音量
      playing: false, // 正在播放
      muted: false, // 静音
      isPlaying: false, // 判断是否正在播放直播
      notSpeedCount: 0, //记录播放速度为0的次数
      flvVideo: null, //播放器
      url: '',
      heartbeatTimer: null, // WebSocket 心跳定时器
      rateOptions: [
        {
          label: '2.0x',
          value: 2.0
        },
        {
          label: '1.5x',
          value: 1.5
        },
        {
          label: '1.25x',
          value: 1.25
        },
        {
          label: '1.0x',
          value: 1.0
        },
        {
          label: '0.75x',
          value: 0.75
        },
        {
          label: '0.5x',
          value: 0.5
        }
      ],
      selectedRate: 1.0
    };
  },
  mounted() {},
  async beforeDestroy() {
    // 作废进行中的自动恢复，并清除延迟回调，防止组件销毁后仍重建播放器
    this._recovering = false;
    this._recoveryToken = (this._recoveryToken || 0) + 1;
    if (this._recoveryTimer) {
      clearTimeout(this._recoveryTimer);
      this._recoveryTimer = null;
    }
    this.destoryVideo();
    this.disconnectWs();
  },
  methods: {
    selectedRateFn(val) {
      this.selectedRate = val;
      this.togglePlay();
    },
    cropingFn() {
      // 获取video元素
      const videoElement = this.$refs.videoPlayer;

      // 检查视频是否已加载
      if (!videoElement || videoElement.readyState < 2) {
        this.$message.warning('视频尚未加载完成，请稍后截图');
        return;
      }

      // 创建canvas元素进行截图
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      // 设置canvas尺寸与视频一致
      canvas.width = videoElement.videoWidth;
      canvas.height = videoElement.videoHeight;

      // 将视频当前帧绘制到canvas上
      ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height);

      try {
        // 将canvas转换为图片数据URL
        const imageDataURL = canvas.toDataURL('image/png');
        if (imageDataURL) {
          this.$emit('setImgUrl', imageDataURL);
        }
        // 创建下载链接
        // this.downloadScreenshot(imageDataURL);
      } catch (error) {
        console.error('截图失败:', error);
        this.$message.error('截图失败，可能是跨域限制');
      }
    },
    // 下载截图
    downloadScreenshot(dataURL) {
      // 创建临时下载链接
      const link = document.createElement('a');
      const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
      const filename = `screenshot-${timestamp}.png`;

      link.href = dataURL;
      link.download = filename;
      link.style.display = 'none';

      // 添加到文档并触发下载
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      this.$message.success('截图已下载');
    },
    // 获取url
    async getUrl() {
      if (!this.devNum) {
        return;
      }
      let url = `${api.monitorDashbord.getMonitVideoUrl}`;
      let params = { devNo: this.devNum };
      params.action = 'requestLiveStream';
      if (this.videoType === 'history') {
        url = `${api.monitorDashbord.getHistoryPlay}`;
        params.startTime = this.startTime;
        params.endTime = this.endTime;
        params.action = 'notify';
      }
      return new Promise(async (resolve, reject) => {
        try {
          const res = await request.post(`${url}`, params);
          if (res.code === 200) {
            // playUrl 后端可能带首尾空格，必须 trim，否则 fetch 流地址失败
            this.url = (res?.data?.playUrl || '').trim(); // 返回视频URL
            resolve(this.url);
          } else {
            this.$message.error('获取视频流地址失败');
            this.url = '';
            reject();
          }
        } catch (error) {
          this.$message.error('获取视频流地址失败');
          this.url = '';
          reject();
        }
      });
    },
    async initVideo(url = this.url, videoId = 'videoPlayercutom') {
      if (!videoId || !url) return;
      let that = this;
      this.destoryVideo();
      const videoElement = this.$refs.videoPlayer;
      // 添加视频元素错误监听（先移除旧监听，避免多次重连后监听器叠加）
      if (this._videoErrorHandler) {
        videoElement?.removeEventListener('error', this._videoErrorHandler);
      }
      this._videoErrorHandler = () => {
        that.refreshVideo();
      };
      videoElement?.addEventListener('error', this._videoErrorHandler);
      const isHistory = this.videoType === 'history';
      let flvPlayer = mpegtsjs.createPlayer(
        {
          type: 'flv',
          url: url,
          isLive: !isHistory,
          enableStashBuffer: isHistory, // 历史回放允许缓冲，直播关闭以降低延迟
          cors: true,
          withCredentials: false,
          hasVideo: true
        },
        {
          liveBufferLatencyChasing: !isHistory // 追帧仅用于直播
        }
      );
      flvPlayer.attachMediaElement(videoElement);
      flvPlayer.load();
      // play() 返回 Promise，若在其 resolve 前调用 pause/load/destroy（快速暂停、切倍速、断流重建）
      // 会 reject AbortError，属正常竞态需静默忽略；其他错误才刷新播放器
      const playResult = flvPlayer.play();
      this.playing = true;
      if (playResult && typeof playResult.catch === 'function') {
        playResult.catch((error) => {
          if (error && error.name === 'AbortError') {
            return;
          }
          console.error('播放失败:', error);
          // 非竞态错误：触发自动重连（refreshVideo 内部按 playing 状态判断是否恢复）
          that.refreshVideo();
        });
      }
      this.flvVideo = flvPlayer;
      //监听播放器发生错误
      flvPlayer.on(mpegtsjs.Events.ERROR, (errorType, errorDetail, errorInfo) => {
        console.log('类型:' + errorType, '报错内容' + errorDetail, '报错信息' + JSON.stringify(errorInfo));
        // 网络错误（流中断/拉取失败）时自动重连
        if (errorType === mpegtsjs.ErrorTypes.NETWORK_ERROR) {
          that.refreshVideo();
        }
      });
      //监听播放信息，该方法会持续调用
      flvPlayer.on(mpegtsjs.Events.STATISTICS_INFO, (e) => {
        //当播放速度为0时，记录一下为0的次数，达到一定次数时，刷新播放器，重新拉取视频流；偶尔卡顿一下不用处理，这里要处理的是长时间拉取不到流，防止链接断开
        if (e.speed == 0) {
          console.log('直播信息：' + JSON.stringify(e));
          if (that.notSpeedCount > 100) {
            that.notSpeedCount = 0;
            that.isPlaying = false;
            that.refreshVideo();
          } else {
            that.notSpeedCount += 1;
          }
        } else {
          if (!that.isPlaying) {
            that.isPlaying = true;
            const resumeResult = flvPlayer.play();
            // 恢复播放时可能与销毁/暂停竞态，忽略 AbortError
            if (resumeResult && typeof resumeResult.catch === 'function') {
              resumeResult.catch(() => {});
            }
          }
          that.notSpeedCount = 0;
        }
      });
    },
    //销毁
    destoryVideo() {
      if (this.flvVideo) {
        this.flvVideo.pause();
        this.flvVideo.unload();
        this.flvVideo.detachMediaElement();
        this.flvVideo.destroy();
        this.flvVideo = null;
      }
    },
    // 刷新播放器：重新请求流地址并重建（带防重入，已暂停则不恢复）
    async refreshVideo() {
      if (this._recovering || !this.playing) return;
      this._recovering = true;
      // 恢复令牌：用户重新播放等操作会作废进行中的恢复
      const token = (this._recoveryToken = (this._recoveryToken || 0) + 1);
      this.isPlaying = false;
      this.destoryVideo();
      try {
        await this.getUrl();
      } catch (e) {
        // getUrl 内部已有错误提示
      }
      // await 期间可能已被销毁/新操作取代，此时不再挂延迟回调
      if (token !== this._recoveryToken) {
        this._recovering = false;
        return;
      }
      this._recoveryTimer = setTimeout(() => {
        this._recoveryTimer = null;
        if (token !== this._recoveryToken) return; // 已被新一轮操作取代
        this._recovering = false;
        if (this.playing && this.url) {
          this.notSpeedCount = 0;
          this.initVideo();
        }
      }, 500);
    },
    async togglePlay() {
      const videoElement = this.$refs.videoPlayer;
      if (!videoElement) {
        return;
      }

      if (this.playing) {
        if (this.flvVideo) {
          this.flvVideo.pause();
        }
        this.playing = false;
        // 作废进行中的自动恢复，防止暂停后又被重建
        this._recovering = false;
        this._recoveryToken = (this._recoveryToken || 0) + 1;
        this.disconnectWs();
      } else {
        // 历史回放必须选择开始和结束时间，且结束时间不能早于开始时间
        if (this.videoType === 'history') {
          if (!this.startTime || !this.endTime) {
            this.$message.warning('请选择开始和结束时间');
            return;
          }
          if (new Date(this.endTime).getTime() < new Date(this.startTime).getTime()) {
            this.$message.warning('结束时间不能早于开始时间');
            return;
          }
        }
        // 作废旧的自动恢复流程，避免与手动播放重复初始化
        this._recovering = false;
        this._recoveryToken = (this._recoveryToken || 0) + 1;
        this.destoryVideo();
        await this.getUrl();
        this.initVideo();
        // 仅直播需要 WebSocket 心跳保活，历史回放不需要
        if (this.videoType !== 'history') {
          this.connectWs();
        }
        this.playing = true;
      }
    },
    // 连接 WebSocket 并启动心跳
    connectWs() {
      // 仅清理本实例的旧心跳定时器，不断开共享连接（WsSocket 为引用计数单例）
      if (this.heartbeatTimer) {
        clearInterval(this.heartbeatTimer);
        this.heartbeatTimer = null;
      }
      WsSocket.connect(`ws://139.9.219.170:8080/biz/ws/aibox`, {
        onOpen: () => {
          // 连接成功后立即发送一次心跳
          WsSocket.send({ devNo: this.devNum, action: 'streamKeepAlive' });
        }
      });
      // 定时发送心跳，每 10 秒一次
      this.heartbeatTimer = setInterval(() => {
        WsSocket.send({ devNo: this.devNum, action: 'streamKeepAlive' });
      }, 10000);
    },
    // 断开 WebSocket 并清除心跳定时器
    disconnectWs() {
      if (this.heartbeatTimer) {
        clearInterval(this.heartbeatTimer);
        this.heartbeatTimer = null;
      }
      WsSocket.disconnect();
    },
    // 暂停心跳（页签切走时调用）：仅停止定时发送，不断开共享连接
    pauseHeartbeat() {
      if (this.heartbeatTimer) {
        clearInterval(this.heartbeatTimer);
        this.heartbeatTimer = null;
      }
    },
    // 恢复心跳（页签切回时调用）：仅直播且播放中才恢复
    resumeHeartbeat() {
      if (this.videoType === 'history' || !this.playing || this.heartbeatTimer) return;
      // 立即补发一次，未连接时 send 会自动入队，重连后发送
      WsSocket.send({ devNo: this.devNum, action: 'streamKeepAlive' });
      this.heartbeatTimer = setInterval(() => {
        WsSocket.send({ devNo: this.devNum, action: 'streamKeepAlive' });
      }, 10000);
    },
    changeVolume(event) {
      const volume = parseFloat(event.target.value);
      this.volume = volume;
      const videoElement = this.$refs.videoPlayer;
      if (videoElement) {
        videoElement.volume = volume;
        // 如果音量大于0，且当前是静音状态，则取消静音
        if (volume > 0 && this.muted) {
          this.muted = false;
          videoElement.muted = false;
        }
        // 如果音量等于0，且当前不是静音状态，则静音
        if (volume === 0 && !this.muted) {
          this.muted = true;
          videoElement.muted = true;
        }
      }
    },
    toggleMute() {
      this.muted = !this.muted;
      const videoElement = this.$refs.videoPlayer;
      if (videoElement) {
        videoElement.muted = this.muted;
        // 如果取消静音，且当前音量为0，则恢复之前的音量（但之前没有记录，所以我们可以用this.volume）
        // 但是，如果我们静音时，音量滑块为0，那么取消静音时，我们需要将音量设置为非0？不对，因为静音时音量滑块可能是0，但非静音时我们希望恢复到之前的音量。
        // 所以我们需要一个变量来记录非静音时的音量。
        if (!this.muted) {
          // 取消静音：将音量设置为之前记录的音量
          this.volume = this.previousVolume;
          videoElement.volume = this.volume;
        } else {
          // 静音：记录当前音量，然后将音量设置为0
          this.previousVolume = this.volume;
          this.volume = 0;
          videoElement.volume = 0;
        }
      }
    },
    toggleFullscreen() {
      const videoContainer = this.$refs.videoPlayer.parentElement;
      if (!document.fullscreenElement) {
        if (videoContainer.requestFullscreen) {
          videoContainer.requestFullscreen();
        } else if (videoContainer.mozRequestFullScreen) {
          videoContainer.mozRequestFullScreen();
        } else if (videoContainer.webkitRequestFullscreen) {
          videoContainer.webkitRequestFullscreen();
        } else if (videoContainer.msRequestFullscreen) {
          videoContainer.msRequestFullscreen();
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.custom-player {
  margin-bottom: 15px;
  background-color: #000;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 8px;
}
.video-player-container {
  width: 100%;
  height: 100%;
  position: relative;

  .video-placeholder {
    width: 108px;
    height: 108px;
    background: url('@/assets/images/start.png') no-repeat center center;

    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .video-player {
    position: absolute;
    width: 100%;
    height: 100%;
    right: 0;
    padding: 0 1px;
  }

  &:hover {
    .player-controls {
      opacity: 1;
    }
  }
}

.control-btn {
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 16px;
  margin: 0 15px;
  padding: 5px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transition: background 0.2s;
  white-space: nowrap;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
  }

  &.fullscreen-btn {
  }
}

.vertical-volume-slider {
  -webkit-appearance: none;
  width: 6px;
  height: 100px;
  background: linear-gradient(to top, #4a90e2, #1ecb80); /* 渐变轨道，从下到上 */
  border-radius: 3px;
  outline: none;
  opacity: 1;
  transform: rotate(0deg); /* 不需要旋转180度了 */
  writing-mode: bt-lr;
  -webkit-appearance: slider-vertical;

  /* 滑块手柄样式 */
  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: white;
    cursor: pointer;
    margin-top: -8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
    transition: transform 0.2s;

    &:hover {
      transform: scale(1.2);
    }
  }
}

.player-controls {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  opacity: 0;
  padding: 10px;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  transition: opacity 0.3s;
  z-index: 10;

  .play-tools {
    display: flex;
    align-items: center;

    .frame-rate {
      color: #fff;
      cursor: pointer;
      font-weight: 600;
      white-space: nowrap;
      width: 100%;
      font-size: 14px;
    }
  }
}

.tools-box {
  background-color: hsla(0, 0%, 8%, 0.9);
  border-radius: 2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
  width: 70px;
  margin: 0;
  padding: 0;

  li {
    color: #fff;
    cursor: pointer;
    height: 22px;
    line-height: 22px;
    list-style: none;

    &.active {
      color: #366bfc;
    }
    &:hover {
      background-color: hsla(0, 0%, 100%, 0.1);
    }
  }
}
</style>
<style lang="scss">
.rate-popper.el-popper {
  min-width: 0 !important;
  width: auto;
  background-color: hsla(0, 0%, 8%, 0.9);
  border: none;
  padding: 0;
  margin: 0;
  margin-bottom: 10px;
  .popper__arrow {
    display: none;
  }
}
</style>
